import React from "react";
import {
  ChevronLeft,
  ChevronRight,
  ChevronsLeft,
  ChevronsRight,
} from "lucide-react";

interface PaginationProps {
  currentPage: number;
  pageLimit: number;
  totalPages: number;
  totalRecords?: number;
  onPageChange?: (page: number) => void;
}

const NAV_BUTTON_CLASS =
  "p-2 border rounded-lg text-gray-500 hover:bg-gray-50 disabled:opacity-40 disabled:cursor-not-allowed disabled:hover:bg-transparent dark:border-gray-700 dark:text-gray-300 dark:hover:bg-gray-700";

const Pagination: React.FC<PaginationProps> = ({
  currentPage,
  totalPages,
  totalRecords = 0,
  onPageChange,
}) => {
  return (
    <div className="flex flex-col md:flex-row items-center justify-between gap-4 mt-4 text-sm">
      <p className="text-gray-500 dark:text-gray-400">
        Total Entries : <span className="font-semibold text-gray-900 dark:text-gray-100">{totalRecords}</span>
      </p>

      <div className="flex items-center gap-3">
        <span className="text-gray-500 dark:text-gray-400">
          Page {totalPages === 0 ? 0 : currentPage} of {totalPages}
        </span>

        <div className="flex items-center gap-1.5">
          <button
            disabled={currentPage === 1}
            onClick={() => onPageChange?.(1)}
            className={NAV_BUTTON_CLASS}
            aria-label="First page"
          >
            <ChevronsLeft size={16} />
          </button>
          <button
            disabled={currentPage === 1}
            onClick={() => onPageChange?.(currentPage - 1)}
            className={NAV_BUTTON_CLASS}
            aria-label="Previous page"
          >
            <ChevronLeft size={16} />
          </button>
          <button
            disabled={currentPage === totalPages || totalPages === 0}
            onClick={() => onPageChange?.(currentPage + 1)}
            className={NAV_BUTTON_CLASS}
            aria-label="Next page"
          >
            <ChevronRight size={16} />
          </button>
          <button
            disabled={currentPage === totalPages || totalPages === 0}
            onClick={() => onPageChange?.(totalPages)}
            className={NAV_BUTTON_CLASS}
            aria-label="Last page"
          >
            <ChevronsRight size={16} />
          </button>
        </div>
      </div>
    </div>
  );
};

export default Pagination;
